export default "__VITE_ASSET__mKcdX1HY__"